import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { CustomField } from './custom-field-model';
import { HttpRepositoryService } from '../../core/http-repository.service';
import { map } from 'rxjs/operators';
import { CustomFieldEditComponent } from '../custom-field-edit/custom-field-edit.component';
import { MessageType } from '../../core/message-dialog/message-type.enum';
import { CustomFieldDeleteComponent } from '../custom-field-delete/custom-field-delete.component';
import { Title } from '@angular/platform-browser';
import { AntiForgeryTokenService } from '../../auth/anti-forgery-token.service';
import { SubSink } from 'subsink';
import { UserCompanyService } from '../../nav-menu/user-company.service';

declare var $: any;
declare var Toast: any;

@Component({
  selector: 'custom-field',
  templateUrl: './custom-field.component.html',
  styleUrls: ['./custom-field.component.css']
})

export class CustomFieldComponent implements OnInit, OnDestroy {

  private customFields: CustomField[] = [];
  private usedInContactList: any[] = [];
  private dataTable: any;
  private dtTable: any;
  private navbarHeadline: any;
  private subs = new SubSink();

  @ViewChild('editModal', { static: false }) editModal: CustomFieldEditComponent;
  @ViewChild('deleteDialog', { static: false }) deleteDialog: CustomFieldDeleteComponent;

  constructor(private repository: HttpRepositoryService,
    private titleService: Title,
    private antiForgery: AntiForgeryTokenService,
    private companyService: UserCompanyService) { }

  ngOnInit() {
    this.subs.sink = this.companyService.currentSelectedCompanyCode.subscribe(resp => {
      this.titleService.setTitle("Link.Maketer - " + resp);
    });

    this.dataTable = $('#customFieldTable');
    this.navbarHeadline = $('#navbarHeadline');
    this.createDataTable();
    this.loadData();
  }

  private createDataTable() {
    var that = this;

    var dtOptions = {
      data: this.customFields,
      columns: [
        {
          name: 'id',
          visible: false
        },
        {
          name: 'name'
        },
        {
          name: 'type',
          width: '200px'
        },
        {
          name: 'insAt',
          width: '200px'
        }
      ],
      orderBy: [[1, 'asc']],
      rowButtons: {
        header: 'Options',
        dropdown: {
          text: '<i class="fas fa-ellipsis-v"></i>',
          class: '',
        },
        buttons: [{
          text: '<i class="fas fa-edit pr-3"></i> Edit',
          class: 'editrow',
          dataAttributes: ['id'],
          action: function (id) {
            that.edit(id);
          }
        },
        {
          text: '<i class="fas fa-trash pr-3"></i> Remove',
          class: 'deleterow',
          dataAttributes: ['id'],
          action: function (id) {
            that.delete(id);
          }
        }
        ]
      },
      buttons: [{
        text: '<i class="fas fa-plus"></i>',
        class: '',
        action: function () {
          that.create()
        }
      },
      {
        text: '<i class="fas fa-trash-alt"></i>',
        class: '',
        action: function () {
          that.deleteList()
        }
      }]
    };

    if (this.dtTable)
      this.dtTable.Destroy();

    this.dtTable = this.dataTable.LinkTable(dtOptions);
  }

  private loadData() {
    this.navbarHeadline.html('Custom fields');

    this.subs.sink = this.repository.get<CustomField[]>('api/CustomField/List').pipe(map(x => x.data))
      .subscribe(fields => {
        this.customFields = fields;
        this.createDataTable();
      });
  }

  create() {
    this.editModal.show(new CustomField(), true);
  }

  edit(id) {
    var customField = this.customFields.find(x => x.id === id);

    if (customField) {
      this.subs.sink = this.repository.get<CustomField>('api/CustomField/Details/' + customField.id).pipe(map(x => x.data))
        .subscribe(data => {

          this.editModal.show(data, false);
        });
    }
  }

  delete(id) {
    var customField = this.customFields.find(x => x.id === id);
    this.usedInContactList = [];

    if (customField) {
      this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
        if (afResp.hasErrors) {
          Toast.Show(afResp.error, 'Delete custom field', 'error');
        } else {
          this.subs.sink = this.repository.get<any>('api/CustomField/Contains?ids=' + id).subscribe(resp => {
            this.usedInContactList = resp.data;

            this.deleteDialog.show("Are you sure you want to delete " + customField.name + "?", MessageType.YESNO, this.usedInContactList, 'Delete confirmation!', () => {
              this.subs.sink = this.repository.del('api/CustomField/Remove/' + id, afResp.data).subscribe(resp => {
                if (resp.hasErrors) {
                  Toast.Show(resp.error, 'Delete custom field', 'error');
                } else {
                  Toast.Show('Custom field successfully removed.', 'Delete custom field', 'success');
                  this.loadData();
                }
              }); 
            });
          }); 
        }
      });
    }
  }

  private onSaved(data: CustomField) {
    var customField = this.customFields.find(x => x.id === data.id);
    if (customField) {
      customField.name = data.name;
      customField.type = data.type;
      customField.insAt = data.insAt;
    } else {
      this.customFields.push(data);
    }

    //todo:reload datatable
    this.createDataTable();
  }

  deleteList() {
    let checked: number[] = this.dtTable._dataTable.rows('.selected').data().toArray().map(x => x.id);
    this.usedInContactList = [];

    if (checked.length == 0) {
      this.deleteDialog.show("You must select custom field(s)!", MessageType.OK, null, "Delete conformation!");
    } else {
      this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
        if (afResp.hasErrors) {
          Toast.Show(afResp.error, 'Delete custom field', 'error');
        } else {
          this.subs.sink = this.repository.get<any>('api/CustomField/Contains?' + checked.map(x => 'ids=' + x + '&').join("")).subscribe(resp => {
            this.usedInContactList = resp.data;

            this.deleteDialog.show("Are you sure you want do delete " + checked.length + " item(s)?", MessageType.YESNO, this.usedInContactList, "Delete conformation", () => {
              this.subs.sink = this.repository.post<any>('api/CustomField/ListRemove', checked, afResp.data).subscribe(resp => {
                if (resp.hasErrors) {
                  Toast.Show(resp.error, 'Delete custom field', 'error');
                } else {
                  Toast.Show('Custom field(s) successfully removed.', 'Delete custom field(s)', 'success');
                  this.loadData();
                }
              });
            });
          });
        }
      });
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();

    if (this.dtTable) {
      this.dtTable.Destroy();
      this.dtTable = null;
    }
  }
}
